<template>
    <v-container v-if="value && article" class="pa-4">
        <v-btn @click="back()"><v-icon>mdi-arrow-left</v-icon></v-btn>
        <v-row no-gutters class="d-flex justify-center align-center mb-4">
            <v-col class="text-center" cols="3">
                <v-icon size="100">mdi-clock-outline</v-icon>
            </v-col>
            <v-col cols="9" class="pl-3">
                <v-row no-gutters align="center">
                    <v-col cols="0">
                        <h3>{{ article.ArticleNumber }}</h3>
                    </v-col>
                </v-row>
                <v-row no-gutters align="center">
                    <v-col cols="0">
                        <QTextArea :value="article.ArticleDescription" singleline :externaledit="false"
                            :disabled="true">
                        </QTextArea>
                    </v-col>
                </v-row>
                <v-row no-gutters align="center">
                    <v-col cols="0">
                        (default price: {{ article.ArticlePrice }})
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row no-gutters align="center">
            <v-col cols="0">
                <QTextField v-model="description" label="Description" :externaledit="false" :disabled="true">
                </QTextField>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field type="number" step="0.5" class="mx-2" label="Hours" v-model="hours" placeholder="Hours"
                    outlined hide-details dense></v-text-field>
            </v-col>
            <v-col>
                <v-text-field class="mx-2" label="Discount" v-model="discount" placeholder="Discount" outlined
                    hide-details dense></v-text-field>
            </v-col>
            <v-col>
                <v-text-field class="mx-2" label="Hourly rate" v-model="price" placeholder="price" outlined hide-details
                    dense></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-menu v-model="showDatePicker" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="date" label="Start Date" prepend-icon="mdi-calendar" readonly
                            v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="date" @input="showDatePicker = false"></v-date-picker>
                </v-menu>
            </v-col>
            <v-col>
                <v-text-field type="time" step="300" min="00:00" v-model="startTime" label="Start Time"></v-text-field>
            </v-col>
            <v-col>
                <v-text-field type="time" step="300" min="00:00" v-model="stopTime" label="Stop Time"></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-select label="Employee" :items="employees" item-text="Name" item-value="Id"
                    :readonly="$store.state.userInfo.UserTypeId != 1" v-model="employmentId"></v-select>
            </v-col>
        </v-row>
        <v-row class="text-right">
            <v-col>
                =
            </v-col>
            <v-col cols="3">
                <h4>{{ Math.round(hours * price * (1 - (discount / 100))) }},-</h4>
            </v-col>
        </v-row>

        <div style="position: fixed; bottom: 40px !important; margin-left: 4px !important;">
            <v-btn color="secondary" outlined @click="remove" :disabled="loading" :loading="loading">
                <v-icon>$delete</v-icon>
                Delete
            </v-btn>
        </div>
        <div style="position: fixed; bottom: 40px !important; right: 16px !important;">
            <v-btn color="primary" @click="save" :disabled="loading" :loading="loading">
                <v-icon>$save</v-icon>
                Save
            </v-btn>
        </div>
    </v-container>
    <v-container v-else>
        <v-progress-circular :size="30" indeterminate></v-progress-circular>
    </v-container>
</template>


<script>
import ClientAPI from "@/api/ClientAPIMixin";
import noimage from "@/assets/noimage.jpg";
import moment from "moment";

export default {
    name: "EditTimeForm",
    emits: ["save"],
    components: {},

    data() {
        return {
            showDatePicker: false,
            value: null,
            noimage: noimage,
            article: null,
            loading: true,
            description: "",
            hours: 0,
            discount: "",
            price: "",
            employees: [],
            employmentId: null,
            timeId: null,
        };
    },

    mounted() {
        this.timeId = this.$route.params.timeId;
        ClientAPI.methods.getEmploymentList().then(data => {
            this.employees = data;
            if (this.timeId)
                this.load();
        });
    },

    methods: {
        back() {
            this.$router.push({ name: "ViewJobParts", params: { filter: this.$route.params.filter, jobId: this.$route.params.jobId } });
        },
        remove() {
            ClientAPI.methods.deleteOrderDetail(this.$route.params.timeId).then(() => {
                this.$emit('partDeleted', { done: () => { this.back(); } });
            })
        },
        save() {
            this.setLoading();
            const item = {
                ArticlePrice: parseFloat(this.price),
                ArticleDescription: this.description,
                ArticleCount: parseFloat(this.hours),
                EmploymentId: this.employmentId,
                EmploymentTimeReportDate: this.value.EmploymentTimeReportDate,
                StartDateTime: this.value.Start,
                StopDateTime: this.value.End,
                Discount: this.discount
            };

            const payload = {
                JobId: this.$route.params.machineJobId,
                Id: this.$route.params.timeId,
                Content: item
            }
            this.$emit('updateTimePart', {
                payload, done: (orderDetail) => {
                    // update v-model if successful
                    this.setAttrs(orderDetail);
                    this.$emit('changed', this.value);
                    this.setLoadingComplete();
                }
            });
        },
        setAttrs(data) {
            if (!this.value) this.value = data;
            else Object.assign(this.value, data);
            this.hours = this.value.Hours;
            this.price = this.value.ArticlePrice;
            this.discount = this.value.Discount;
            this.description = this.value.Text;
            this.employmentId = this.value.EmploymentId;
        },
        load() {
            ClientAPI.methods.getJobTime(this.timeId).then(data => {
                this.setAttrs(data);
                ClientAPI.methods.getPart(this.value.ArticleNumber).then(data => {
                    this.article = data;
                }).then(() => {
                    this.setLoadingComplete();
                });
            })
        },
        setLoading() {
            this.loading = true;
        },
        setLoadingComplete() {
            this.loading = false;
        },
        imageLoadError(item) {
            item.ArticleImage = noimage;
        },
    },

    computed: {
        date: {
            get: function () {
                if (this.value.EmploymentTimeReportDate)
                    return new Date(this.value.EmploymentTimeReportDate).toISOString().substring(0, 10)
                else if (this.value.Start) {
                    return new Date(this.value.Start).toISOString().substring(0, 10)
                }
                return new Date().toISOString().substring(0, 10)
            },
            set: function (val) {
                this.value.EmploymentTimeReportDate = new Date(val).toISOString().substring(0, 10);
            }
        },
        startTime: {
            get: function () {
                var dateTime = moment(this.date);
                if (this.value.Start) {
                    dateTime = moment(this.value.Start)
                }
                return dateTime.format("HH:mm:ss");
            },
            set: function (val) {
                this.value.Start = moment(this.date + ' ' + val)
                this.value.End = moment(this.value.Start).add(this.hours, 'hours')
            }
        },
        stopTime: {
            get: function () {
                var dateTime = moment(this.date);
                if (this.value.Start)
                    dateTime = moment(this.value.Start).add(this.hours, 'hours')

                return dateTime.format("HH:mm:ss");
            },
            set: function (val) {
                const endDateTime = moment(this.date + ' ' + val)
                const startDateTime = moment(this.date + ' ' + this.startTime)
                this.value.End = endDateTime;
                this.hours = endDateTime.diff(startDateTime, 'hours', true).toFixed(2);
            }
        }
    },

    watch: {
        "$route.params.timeId": {
            handler: function () {
                this.article = null;
                this.value = null;
                this.timeId = this.$route.params.timeId;
                this.load();
            }
        },
        hours(val) {
            if (this.value.Start)
                this.value.End = moment(this.value.Start).add(val, 'hours')
        }
    }
}
</script>
